import { useCallback, useMemo } from "react"
import { useDeleteConfirm } from "../../../../hooks/useDeleteConfirm"
import { useDeprecatedDevices } from "../../../../hooks/useDeprecatedDevices"
import { DimaFeatureShortNameEnum } from "../../../models/Authorization"
import { DeprecatedDeviceGet } from "../../../models/DeprecatedDevice"
import { deleteEntity } from "../../../utils/deleteEntity"
import { DiMaAddButton } from "../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../partials/EntityTab"

export function KeyValuePairs() {
  const { deprecatedDevicesList, isLoadingDeprecatedDevices } = useDeprecatedDevices()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const columns = [
    {
      field: "deviceSerialNumber",
      headerName: "Device Serial Number",
      isLink: true,
      linkBasePath: "/deprecated-devices",
    },
    { field: "certificateSerialNumber", headerName: "Certificate Serial Number" },
  ]

  const sorted = [...deprecatedDevicesList].sort((a, b) =>
    (a.deviceSerialNumber ?? "").localeCompare(b.deviceSerialNumber ?? "")
  )

  const rows = sorted.map((device: DeprecatedDeviceGet) => ({
    id: device.id,
    deviceSerialNumber: device.deviceSerialNumber,
    certificateSerialNumber: device.certificateSerialNumber,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url="/deprecated-devices/create"
        feature={DimaFeatureShortNameEnum.DD}
      />
    ),
    []
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string; iconName?: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() => deleteEntity(`/deprecatedDevices/${row.id}`))
      }
    },
    [requestDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={columns}
        isLoading={isLoadingDeprecatedDevices}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
